import { Link } from 'react-router-dom';
import { moduleCards } from '@/components/DashboardLayout';

function Icon({ path, className = 'w-6 h-6' }: { path: string; className?: string }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={path} />
    </svg>
  );
}

export default function DashboardPage() {
  return (
    <div>
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-dark-900 mb-2">Bem-vindo ao Stock-In</h1>
        <p className="text-dark-500">Selecione um módulo para começar</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {moduleCards.filter(c => c.targetPage !== '/dashboard').map((card) => (
          <Link
            key={card.title}
            to={card.targetPage}
            className="group bg-white rounded-2xl p-6 border border-dark-100 hover:border-primary-300 hover:shadow-lg transition-all duration-200"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-primary-50 group-hover:bg-primary-100 flex items-center justify-center transition-colors">
                <Icon path={card.icon} className="w-6 h-6 text-primary-600" />
              </div>
              <svg
                className="w-5 h-5 text-dark-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-dark-900 mb-2">{card.title}</h3>
            <p className="text-sm text-dark-500">
              {card.items.length} {card.items.length === 1 ? 'item disponível' : 'itens disponíveis'}
            </p>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {card.items.slice(0, 3).map((item) => (
                <span
                  key={item.href}
                  className="text-xs px-2 py-1 bg-dark-50 text-dark-600 rounded-md"
                >
                  {item.label}
                </span>
              ))}
              {card.items.length > 3 && (
                <span className="text-xs px-2 py-1 bg-dark-50 text-dark-600 rounded-md">
                  +{card.items.length - 3}
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
